import { dispatch } from "../../state/store";
import { setNotificationsRefresh } from "../../state/ducks";

import { strCode } from "../../consts";
import { log, notificationService, s3ImageService, t } from "../../services";
import { responseUtil } from "../../utils";

export const useUploadNotificationImage = () => {
  const mutationCallback = async (imageUrl, binaryImage) => {
    try {
      const response = await s3ImageService.uploadImage(imageUrl, binaryImage);

      if (responseUtil.isResponseSuccessful(response)) {
        notificationService.showSuccess({
          title: t(strCode.NOTIFICATION_IMAGE_UPLOAD_SUCCESS)
        });

        dispatch(setNotificationsRefresh(true));
      }
    } catch (err) {
      log.error("useUploadNotificationImage: Failed to upload notification image", err);
      notificationService.showError({
        title: t(strCode.NOTIFICATION_IMAGE_UPLOAD_ERROR),
        message: err?.response?.data?.message ? err.response.data.message : err?.toString()
      });
    }
  };

  return { mutationCallback };
};
